import * as styles from "./Overlay.css";

import { type MouseEvent } from "react";

import { useAddressBookActions } from "../../hooks/useAddressBookActions";
import type { OverlayProps } from "./Overlay.types";

export function Overlay({
  isVisible,
  background,
  contained,
  children,
}: OverlayProps) {
  const { hide } = useAddressBookActions();

  const handleOverlayClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();

    if (e.target === e.currentTarget) {
      console.log("Overlay clicked", { e });
      hide();
    }
  };

  return (
    <div
      className={styles.overlay({ isVisible, background, contained })}
      onClick={handleOverlayClick}
    >
      {children}
    </div>
  );
}
